// styles
import { chartDashboardBoxStyle, chartDashboardType02SamsungStyle } from 'styles';

// libraries
import styled from 'styled-components';

interface PjtInformationProps {
  $progress: number;
}

export const StyledPjtInformation = styled.div<PjtInformationProps>`
  ${chartDashboardBoxStyle}
  ${chartDashboardType02SamsungStyle}
  
  height: auto;
  min-height: inherit;

  .pjt-lists {
    .pjt-list {
      .progress {
        position: relative;
        width: 100%;
        background-color: #141d1c;
        border-radius: 8px;
        overflow: hidden;
        color: var(--color-white) !important;
        z-index: 1;

        > span {
          color: var(--color-white) !important;
          display: block;
          position: relative;
          z-index: 2;
          text-align: center;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }

        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          width: ${({ $progress }) => $progress}%;
          height: 100%;
          border-radius: 8px;
          background-color: var(--color-primary-blue);
          transform: translateY(-50%);
        }
      }
    }
  }
`;
